// extracted by mini-css-extract-plugin
export default {"details":"p3rIZ","chevron":"X7SHf","summary":"t1Y9c","answer":"OW3h6"};